import API_CLIENT from "../../utils/Api";

export async function GetProducts(searchTerm = "", page) {
  return await API_CLIENT.get(`/products?search=${searchTerm}&page=${page}`);
}

export async function GetProductOverview() {
  return await API_CLIENT.get("/products/overview");
}
